import React from "react";
import { Link } from "react-router-dom";
import friend from '../../assest/image/Friends.png';
function InvestRealState2() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-right" className="container-fluid row  vh-100 w-100">
            <div className="col-sm-6 d-flex justify-content-center align-items-start my-auto text-center">
                <div className="bg-white rounded-border py-5 px-5 border border-4 border-dark">
                  <p className="py-5 my-5">Unfortunately, one of the friends made a significant mistake that will only be revealed in the distant future.</p>
                  <Link to={'/investing-in-real-estate/third-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
            <div className="col-sm-6 d-flex align-items-center justify-content-center position-relative">
              <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
               <img src={friend} className="frndImage" alt="friend" />
               </div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState2;
